import React from 'react';
import { imgPlaySvg } from '~/src/images';
import { PlaylistItem } from '~/src/models/YouTube';
import Picture from '~/src/overtime-lib/src/www/components/Picture';
import './Video.scss';

const Video = ({ youTubeVideo }: { youTubeVideo: PlaylistItem }) => {
	if (!youTubeVideo) {
		return <></>;
	}
	const imagePath = Object.values(youTubeVideo.snippet.thumbnails).reduce(
		(best, t) => (t.width > best.width ? t : best),
		{
			width: 0,
		},
	).url;

	return (
		<div className="GameVideo">
			<a href={`https://www.youtube.com/v/${youTubeVideo.id}`} title={youTubeVideo.snippet.title}>
				<Picture
					src={`https://images.itsovertime.com/youtube${new URL(imagePath).pathname}`}
					alt={youTubeVideo.snippet.title}
					mobileWidth={640}
				/>
				<img className="Play" alt="Play Video" src={imgPlaySvg} />
			</a>
		</div>
	);
};

export default Video;
